import * as React from 'react'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import ResultsInfo from './resultsInfo'
import Suggestions from './suggestions'

interface IProps {
  locationParams: ILocationParams
  totalHits: number
  didYouMeanByTerms: any[]
  authorSuggestion: any
  seoMeta: any
  styles: any
  TagName: string
}

const SearchResultHeaders = (props: IProps) => {
  const {
    totalHits = 0,
    didYouMeanByTerms = [],
    authorSuggestion,
    seoMeta,
    styles
  } = props
  const shouldShowSeo = seoMeta && seoMeta.heading && totalHits > 0

  return (
    <div className={styles.mainContainer}>
      {(Array.isArray(didYouMeanByTerms) && didYouMeanByTerms.length) ||
      authorSuggestion ? (
        <Suggestions {...props} />
      ) : null}
      {shouldShowSeo && <ResultsInfo {...props} />}
    </div>
  )
}

export default SearchResultHeaders
